import { SceneCanvas } from "konva/lib/Canvas.js";
import { Factory } from "konva/lib/Factory.js";
import { _registerNode } from "konva/lib/Global.js";
import { Util } from "konva/lib/Util.js";
import { getBooleanValidator, getNumberOrAutoValidator, getNumberValidator, getStringOrGradientValidator, getStringValidator } from "konva/lib/Validators.js";
import { Text } from "konva/lib/shapes/Text.js";
import { markdownToSlate } from "./SharedTransforms.js";
import { calcInheritedBounds } from "./CustomImage.js";

var DISABLE_CANVAS = true
var AUTO = 'auto',
  //CANVAS = 'canvas',
  CENTER = 'center',
  INHERIT = 'inherit',
  JUSTIFY = 'justify',
  CHANGE_KONVA = 'Change.konva',
  CONTEXT_2D = '2d',
  DASH = '-',
  LEFT = 'left',
  LTR = 'ltr',
  TEXT = 'text',
  TEXT_UPPER = 'Text',
  TOP = 'top',
  BOTTOM = 'bottom',
  MIDDLE = 'middle',
  NORMAL = 'normal',
  PX_SPACE = 'px ',
  SPACE = ' ',
  RIGHT = 'right',
  RTL = 'rtl',
  WORD = 'word',
  CHAR = 'char',
  NONE = 'none',
  ELLIPSIS = '…',
  ATTR_CHANGE_LIST = [
    'direction',
    'fontFamily',
    'fontSize',
    'fontStyle',
    'fontVariant',
    'padding',
    'align',
    'verticalAlign',
    'lineHeight',
    'text',
    'width',
    'height',
    'wrap',
    'ellipsis',
    'letterSpacing',
  ],
  // cached variables
  attrChangeListLen = ATTR_CHANGE_LIST.length;


const HEATMAP = {
  colors:[
    "#f6d7dc",
    "#fbeadb",
    "#fcfcf7",
    "#e5f1e3",
    "#cae5df"
  ]
}

var dummyContext;
function getDummyContext() {
    if (dummyContext) {
        return dummyContext;
    }
    dummyContext = Util.createCanvasElement().getContext(CONTEXT_2D);
    dummyContext.textBaseline = MIDDLE
    return dummyContext;
}
  function normalizeFontFamily(fontFamily) {
      return fontFamily
        .split(',')
        .map((family) => {
          family = family.trim();
          const hasSpace = family.indexOf(' ') >= 0;
          const hasQuotes = family.indexOf('"') >= 0 || family.indexOf("'") >= 0;
          if (hasSpace && !hasQuotes) {
            family = `"${family}"`;
          }
          return family;
        })
        .join(', ');
    }
    

class CustomText extends Text {
  _resolveFontStyleAndWeight(styleInput, weightInput) {
    let resolvedStyle = styleInput ?? NORMAL;
    let resolvedWeight = weightInput;

    if (typeof resolvedStyle === 'string') {
      const tokens = resolvedStyle.split(/\s+/).filter(Boolean);
      let styleToken = NORMAL;
      let weightToken = resolvedWeight;

      tokens.forEach((token) => {
        const lower = token.toLowerCase();
        if (lower === 'italic' || lower === 'oblique') {
          styleToken = lower;
          return;
        }
        if (lower === 'bold') {
          weightToken = weightToken ?? 700;
          return;
        }
        if (lower === 'light') {
          weightToken = weightToken ?? 300;
          return;
        }
        if (/^\d{3}$/.test(lower)) {
          weightToken = Number(lower);
          return;
        }
        if (lower === 'normal') {
          return;
        }
      });

      resolvedStyle = styleToken;
      resolvedWeight = weightToken;
    }

    if (resolvedStyle !== 'italic' && resolvedStyle !== 'oblique') {
      resolvedStyle = NORMAL;
    }

    if (resolvedWeight == null) {
      resolvedWeight = 'normal';
    }

    return { style: resolvedStyle, weight: resolvedWeight };
  }

  _buildPrivateCache(){
    if( this.textWidth === 0){
        return
    }

    let w = this.attrs.width//this.width()
    let h = this._cachedHeight

      const canvas = Util.createCanvasElement();
      if (!canvas) {
        this.pcache = undefined
        return
      }
      this.pcache = canvas;
      this.pcache.width = w * this.scaleRatio;
      this.pcache.height = h * this.scaleRatio;
      const context = this.pcache.getContext('2d');
      if (!context) {
        this.pcache = undefined
        return
      }
      this.pcache._canvas_context = context;


      if (this.pcache.style) {
        this.pcache.style.padding = '0';
        this.pcache.style.margin = '0';
        this.pcache.style.border = '0';
        this.pcache.style.position = 'absolute';
        this.pcache.style.top = '0';
        this.pcache.style.left = '0';
      }


      this.attrs.bgFill = this.attrs.bgFill || "white"


      this.lastScale = 1
    this.uWidth = this.pcache.width
    this.uHeight = this.pcache.height

    this.pcache._canvas_context.fillStyle = this.attrs.bgFill
    this.pcache._canvas_context.fillRect(0,0,  this.uWidth, this.uHeight)
    this.pcache._canvas_context.font = this.fontCache
    this.pcache._canvas_context.textBaseline = MIDDLE
    this.pcache._canvas_context.textAlign = LEFT


  }
  getHeight() {
    if( this.attrs.withMarkdown ){
      var isAuto = this.attrs.height === AUTO || this.attrs.height === undefined;

      const lastItem = this.textArr.slice(-1)?.[0]

      if( lastItem?.tableInfo ){
        return lastItem?.tableInfo.tableHeight
      }

      return isAuto
      ? (lastItem?.y ?? 0) + (this.lineHeight() * this.fontSize() / 2)
      : this.attrs.height;
    }else{
      return super.getHeight()
    }
  }
  _addMDTextLine(line, metrics, indent, y, bold, italic, large, bullet, color, fontScale, tableInfo) {
      const align = this.align();
      if (align === JUSTIFY) {
          line = line.trim();
      }
      return this.textArr.push({
          text: line,
          width: metrics.width,
          ascent: metrics.ascent,
          descent: metrics.descent,
          y: y,
          bold: bold,
          italic: Boolean(italic),
          large: large,
          bullet: bullet,
          indent: indent,
          lastInParagraph: false,
          fontScale: fontScale,
          tableInfo,
          color
      });
  }
  setFont
  _getTextStats(text) {
      const metrics = getDummyContext().measureText(text)
      return {width: metrics.width, ascent: metrics.actualBoundingBoxAscent, descent: metrics.actualBoundingBoxDescent}
  }

    _MDtryToAddEllipsisToLastLine() {
        var width = this.attrs.width, fixedWidth = width !== AUTO && width !== undefined, padding = this.padding(), maxWidth = width - padding * 2, shouldAddEllipsis = this.ellipsis();
        var lastLine = this.textArr[this.textArr.length - 1];
        if (!lastLine || !shouldAddEllipsis) {
            return;
        }
        if (fixedWidth) {
            var haveSpace = this._getTextWidth(lastLine.text + ELLIPSIS) < maxWidth;
            if (!haveSpace) {
                lastLine.text = lastLine.text.slice(0, lastLine.text.length - 3);
            }
        }
        //lastLine.text += ELLIPSIS
        //lastLine.width = this._getTextWidth(lastLine.text);
        this.textArr.splice(this.textArr.length - 1, 1);
        this._addMDTextLine(lastLine.text + ELLIPSIS, 
                            {width:lastLine.width, ascent: lastLine.ascent, descent: lastLine.descent},
                            lastLine.indent, 
                            lastLine.y, 
                            lastLine.bold,
                            lastLine.italic,
                            lastLine.large,
                            lastLine.bullet,
                            lastLine.color,
                            lastLine.fontScale,
                            lastLine.tableInfo
        )
    }


    _getContextFont(options = {}) {
      const baseStyle = options.style ?? this.fontStyle();
      const baseWeight = options.weight;
      const { style: resolvedStyle, weight: resolvedWeight } = this._resolveFontStyleAndWeight(
        baseStyle,
        baseWeight
      );
      const fontVariant = options.variant ?? this.fontVariant();
      const fontSize = options.size ?? this.fontSize();
      const fontFamily = normalizeFontFamily(options.family ?? this.fontFamily());

      return (
        resolvedStyle +
        SPACE +
        fontVariant +
        SPACE +
        resolvedWeight +
        SPACE +
        (fontSize + PX_SPACE) +
        fontFamily
      );
    }

_setTextData() {
  /*if( !this.text().startsWith("### Brand\nPet Travel Hub by Mars Petcare & Tripadviso")){
    return this._setTextDataOLD()
  }*/

    this.fontCache = this._getContextFont()
    

  const baseFontSize = this.fontSize();
  let baseStyle = this.fontStyle() || "normal";
  let normalWeight = "normal";
  let boldWeight = "bold";

  if (this.fontStyle() === "light") {
    baseStyle = "normal";
    normalWeight = 300;
    boldWeight = 500;
  } else if (this.fontStyle() === "bold") {
    baseStyle = "normal";
    normalWeight = 600;
    boldWeight = 900;
  } else if (this.fontStyle() !== "italic") {
    baseStyle = "normal";
  } else {
    baseStyle = "italic";
  }

  const headlineWeight = boldWeight;

  this.standardFont = this._getContextFont({ style: baseStyle, weight: normalWeight });
  this.standardFontItalic = this._getContextFont({ style: "italic", weight: normalWeight });
  this.boldFont = this._getContextFont({ style: baseStyle, weight: boldWeight });
  this.boldFontItalic = this._getContextFont({ style: "italic", weight: boldWeight });
  this.headlineFont = this._getContextFont({ style: baseStyle, weight: headlineWeight, size: baseFontSize * 1.5 });
  this.headlineFontItalic = this._getContextFont({ style: "italic", weight: headlineWeight, size: baseFontSize * 1.5 });

  /*window.fonttrack ||= {}
  window.fonttrack[this.standardFont] = (window.fonttrack[this.standardFont] ?? 0)+1
  window.fonttrack[this.boldFont] = (window.fonttrack[this.boldFont] ?? 0)+1
  window.fonttrack[this.headlineFont] = (window.fonttrack[this.headlineFont] ?? 0)+1*/

  if( !this.attrs.withMarkdown ){
    super._setTextData()
    this._cachedHeight = this.height()
    return
  }

  const formattedList = markdownToSlate( this.text()) 
  const p = formattedList[formattedList.length - 1]
  if( p.children.length === 1 && p.type === "paragraph" && p.children[0]?.text?.length === 0 ){
    formattedList.pop()
  }
  if( this.tableDecoration ){
    delete this["tableDecoration"]
  }
  
  var fontSize = +this.fontSize(),
      baseLineHeightPx = this.lineHeight() * fontSize, 
      width = this.attrs.width, 
      height = this.attrs.height, 
      fixedWidth = width !== AUTO && width !== undefined, 
      fixedHeight = height !== AUTO && height !== undefined, 
      padding = this.padding(), 
      maxWidth = width - padding * 2, 
      maxHeightPx = height - padding * 2, 
      currentHeightPx = 0, 
      wrap = this.wrap(), 
      shouldWrap = wrap !== NONE, 
      wrapAtWord = wrap !== CHAR && shouldWrap, 
      shouldAddEllipsis = this.ellipsis(),
      sectionSpacing = this.attrs.sectionSpacing

  let translateY
  let lineHeightPx 
  this.textArr = [];
  
  var additionalWidth = shouldAddEllipsis ? this._getTextStats(ELLIPSIS).width : 0;

  let placeTextWidth = maxWidth
  let fontScaleForTable = 1
  

  const placeText = ( text, large, bold, italic, drawBullet, startIndent, indent, color, lastLine, tableInfo )=>{
    
    let targetFont = this._fontForFlags({ bold, italic, large });
    if( fontScaleForTable != 1){
      const size = targetFont.match(/(\d+(?:\.\d+)?)px/)
      targetFont = targetFont.replace(size[0], (size[1] * fontScaleForTable) + "px")
    }
    getDummyContext().font = targetFont
    
    let lineMetrics = this._getTextStats(text)
    let lineWidth = lineMetrics.width + indent;
    var leaveForHeight = false
    let advanced = false
    let textWidth = 0
    
    if( translateY === undefined || tableInfo?.first){
      translateY = lineHeightPx / 2 ;
    }

    if (lineWidth > placeTextWidth) {
      let frag = 0, retry = false
      while (text.length > 0) {
          var low = 0, high = text.length, match = '', matchWidth = 0;
          while (low < high) {
              var mid = (low + high) >>> 1, substr = text.slice(0, mid + 1), substrWidth = this._getTextStats(substr).width + additionalWidth + indent
              if (substrWidth <= placeTextWidth) {
                  low = mid + 1;
                  match = substr;
                  matchWidth = substrWidth;
              }
              else {
                  high = mid;
              }
          }
          if (match) {
              let matchMetrics
              if (wrapAtWord) {
                  var wrapIndex;
                  var nextChar = text[match.length];
                  var nextIsSpaceOrDash = nextChar === SPACE || nextChar === DASH;
                  if (nextIsSpaceOrDash && matchWidth <= placeTextWidth) {
                      wrapIndex = match.length;
                  }
                  else {
                      wrapIndex =
                          Math.max(match.lastIndexOf(SPACE), match.lastIndexOf(DASH)) +
                              1;
                  }
                  if (wrapIndex > 0) {
                      low = wrapIndex;
                      match = match.slice(0, low);
                    }
                    matchMetrics = this._getTextStats(match)
                    matchWidth = matchMetrics.width + indent;
              }
              match = match.trimRight();
              this._addMDTextLine(match, matchMetrics, indent, currentHeightPx + translateY, bold, italic, large, drawBullet && (frag === 0), color, fontScaleForTable, tableInfo);
              indent = startIndent
              textWidth = Math.max(textWidth, matchWidth);
              currentHeightPx += lineHeightPx;
              advanced = true
              var shouldHandleEllipsis = this._shouldHandleEllipsis(currentHeightPx);
              if (shouldHandleEllipsis) {
                  this._MDtryToAddEllipsisToLastLine();
                  leaveForHeight = true
                  break;
              }
              text = text.slice(low);
              text = text.trimLeft();
              if (text.length > 0) {
                  lineMetrics = this._getTextStats(text)
                  lineWidth = lineMetrics.width + indent;
                  if (lineWidth <= placeTextWidth) {
                      this._addMDTextLine(text, lineMetrics, indent, currentHeightPx + translateY, bold, italic, large, false, color, fontScaleForTable, tableInfo);
                      advanced = false
                      textWidth = Math.max(textWidth, lineWidth);
                      break;
                  }
              }
          }
          else {
              break;
          }
          frag++
          if( leaveForHeight ){
            break
          }
      }
      if( frag === 0 && indent > startIndent ){
        currentHeightPx += lineHeightPx;
        const partial = placeText( text, large, bold, italic, drawBullet, startIndent, startIndent, color, lastLine, tableInfo )
        indent = partial.indent
        advanced = partial.advanced
        textWidth = partial.textWidth
        lineWidth = partial.indent

      }
    }else {
      this._addMDTextLine(text, lineMetrics, indent, currentHeightPx + translateY, bold, italic, large, drawBullet, color, fontScaleForTable, tableInfo);
      textWidth = Math.max(textWidth, lineWidth);
      if (this._shouldHandleEllipsis(currentHeightPx ) && !lastLine) {
        this._MDtryToAddEllipsisToLastLine();
        leaveForHeight = true
      }
    }
    indent = lineWidth

    return {indent: indent, newline: advanced, clippedForHeight: leaveForHeight, textWidth}
  }

  let maxUsedWidth = 0
  let lastWasHeading, lastWasListItem,lastLineHeight
  let startIndent = 0
  let clipped


  let indentWidths = []

  const processSection = ( section, lastSection, tableInfo, partOfListItem )=>{
    if( clipped ){
      return
    }
    const isHeading = section.type === "heading"
    const isListItem = section.type === "list-item" || partOfListItem
    const large = isHeading


    let didAdvance = false, needAdvance = false
    lineHeightPx = large ? baseLineHeightPx * 1.2 : baseLineHeightPx
    const sectionStart = currentHeightPx

    if( section.type === "unordered-list" || section.type === "ordered-list"){
      const px = "" + lineHeightPx
      if( !indentWidths[px] ){
        getDummyContext().font = (large ? this.headlineFont : this.standardFont)
        indentWidths[px] = this._getTextStats("    ").width
      }
      let preIndent = startIndent
      startIndent += indentWidths[px]
      
      if( section.children ){
          currentHeightPx += (lineHeightPx * 0.35);
        for(const sub of section.children ){
          processSection( sub, false, false )
        }
        if(this.textArr[this.textArr.length - 1]) {
          this.textArr[this.textArr.length - 1].lastInParagraph = true;
        }
      }

      startIndent = preIndent
    }else if( section.type === "table"){
      const rows = section.children
      const startX = startIndent
      this.tableDecoration ||= []
      if(rows.length > 0){
        const columnCount = rows[0].children.length
        const mainLineHeight = baseLineHeightPx
        //const heatRegex = /^(\d+)(?: - | – |: |\s+)(.*)$/
        //const heatOrSentimentRegex = /^(?:(\d+)|(strongly negative|slightly negative|neutral|slightly positive|strongly positive))(?: - | – |: |\s+)(.*)$/i;
        const heatOrSentimentRegex = /^(?:(\d+)|(strongly negative|slightly negative|neutral|slightly positive|strongly positive))(?: - | – |: |\s+)?(.*)?$/i;

        const baseRowSpacing = mainLineHeight * 0.2
        const baseColSpacing = mainLineHeight * 0.1
        // Allow developers to pin column widths. section.columnWidths can be
        // an array or object mapping column index to width. Unspecified columns
        // will be sized based on their content, similar to browser table layout.
        const specifiedWidths = section.columnWidths || {}
        const columnMinBase = new Array(columnCount).fill(0)
        const columnMaxBase = new Array(columnCount).fill(0)

        const extractText = (node) => {
          if (typeof node.text === 'string') return node.text
          if (Array.isArray(node.children)) {
            return node.children.map(extractText).join('')
          }
          return ''
        }

        const measurementFont = this._getContextFont({size: this.fontSize()})
        getDummyContext().font = measurementFont
        const spaceWidthBase = this._getTextStats(' ').width
        const measureCell = (cell) => {
          const text = extractText(cell) || ''
          const run = text.replace(/\s+/g, ' ').trim()
          if (!run) return {min: baseColSpacing * 2, max: baseColSpacing * 2}
          const parts = run.split(' ')
          let minW = 0
          let maxW = 0
          parts.forEach((part, i) => {
            const w = this._getTextStats(part).width
            maxW += w
            if (i < parts.length - 1) maxW += spaceWidthBase
            if (w > minW) minW = w
          })
          minW += baseColSpacing * 2
          maxW += baseColSpacing * 2
          return {min: minW, max: maxW}
        }

        for (const row of rows) {
          row.children.forEach((col, idx) => {
            const defined = specifiedWidths[idx]
            if (defined == null) {
              const {min, max} = measureCell(col)
              if (min > columnMinBase[idx]) columnMinBase[idx] = min
              if (max > columnMaxBase[idx]) columnMaxBase[idx] = max
            }
          })
        }

        const columnSize = new Array(columnCount).fill(0)
        let fixedTotal = 0
        const autoIdx = []
        for (let i = 0; i < columnCount; i++) {
          const w = specifiedWidths[i]
          if (w != null) {
            columnSize[i] = w
            fixedTotal += w
          } else {
            autoIdx.push(i)
          }
        }

        const tableWidth = maxWidth - startX
        let available = Math.max(0, tableWidth - fixedTotal)



        if (autoIdx.length) {
          const baseTotalMin = autoIdx.reduce((sum, i) => sum + columnMinBase[i], 0)

          if (baseTotalMin > 0 && available > 0) {
            const scaleToFit = available / baseTotalMin
            if (scaleToFit < 1) {
              fontScaleForTable = scaleToFit
            }
          }
        }

        const scaledLineHeight = mainLineHeight * fontScaleForTable
        const rowSpacing = baseRowSpacing * fontScaleForTable
        const colSpacing = baseColSpacing * fontScaleForTable
        baseLineHeightPx = scaledLineHeight

        const columnMin = columnMinBase.map(v => v * fontScaleForTable)
        const columnMax = columnMaxBase.map(v => v * fontScaleForTable)
        const totalMin = autoIdx.reduce((sum, i) => sum + columnMin[i], 0)
        const totalMax = autoIdx.reduce((sum, i) => sum + columnMax[i], 0)

        if (autoIdx.length) {
          if (available <= totalMin) {
            autoIdx.forEach(i => { columnSize[i] = columnMin[i] })
          } else if (available >= totalMax) {
            autoIdx.forEach(i => { columnSize[i] = columnMax[i] })
            const extra = (available - totalMax) / autoIdx.length
            if (extra > 0) {
              autoIdx.forEach(i => { columnSize[i] += extra })
            }
          } else {
            const remaining = available - totalMin
            const flexTotal = autoIdx.reduce((sum, i) => sum + (columnMax[i] - columnMin[i]), 0)
            autoIdx.forEach(i => {
              const flex = columnMax[i] - columnMin[i]
              const add = flexTotal > 0 ? remaining * (flex / flexTotal) : remaining / autoIdx.length
              columnSize[i] = columnMin[i] + add
            })
          }
        }

        let maxForRow = 0
        let startRow = currentHeightPx 
        let rIdx = 0
        for( const row of rows){
          const isHeaderRow = Boolean(row.isHeader);
          startRow += maxForRow
          currentHeightPx = startRow
          maxForRow = 0
          let cIdx = 0
          startIndent = startX + colSpacing
          let fills = []
          for(const col of row.children){
            const cellInnerWidth = Math.max(columnSize[cIdx] - (colSpacing * 2), colSpacing);
            const cellRightEdge = startIndent + cellInnerWidth;
            placeTextWidth = Math.min(maxWidth, cellRightEdge);
            currentHeightPx = startRow + rowSpacing
            let firstOfCell = true
            if( isHeaderRow ){
                fills[cIdx] = this.attrs.tableHeaderFill ?? "#999999"
            }else{

              //const m = col.children[0].children?.[0]?.text?.match(heatRegex)
              const m = col.children[0]?.text?.match(heatOrSentimentRegex)
              if (false && m) {
                let v;
              
                if (m[1]) {
                  // Case: number found (Group 1)
                  v = parseInt(m[1], 10) - 1;
                  if (v > 4) v = 4;
                  col.children[0].text = m[3]
                } else if (m[2]) {
                  // Case: sentiment found (Group 2)
                  const sentimentText = m[2].toLowerCase();
                  const sentimentScale = {
                    "strongly negative": 0,
                    "slightly negative": 1,
                    "neutral": 2,
                    "slightly positive": 3,
                    "strongly positive": 4
                  };
                  v = sentimentScale[sentimentText];
                }
              
                if (v !== undefined) {
                  fills[cIdx] = HEATMAP.colors[v];
                }
              }
            }
            for(const child of col.children){
              processSection( child, false, {first: firstOfCell, col: cIdx, row: rIdx, isHeader: isHeaderRow, xPadding: colSpacing, yPadding: rowSpacing, fill: fills[cIdx]} )
              firstOfCell = false
            }
            startIndent += columnSize[cIdx]
            const rowHeight = currentHeightPx - startRow
            maxForRow = rowHeight > maxForRow ? rowHeight : maxForRow
            cIdx++
          }
          let sx = startX
          maxForRow += rowSpacing * 2 
          for( let cIdx = 0; cIdx < columnCount; cIdx++){
            const fill = fills[cIdx]
            
            this.tableDecoration.push({
              type: "rect",
              x: sx,
              y: startRow,
              width: columnSize[cIdx],
              height: maxForRow ,
              fill,
              stroke: "#999999",
            })
            sx += columnSize[cIdx]
          }
          rIdx++
        }
        startIndent = startX
        placeTextWidth = maxWidth
        currentHeightPx = startRow + maxForRow + rowSpacing
        if( this.textArr[this.textArr.length - 1]?.tableInfo){
          this.textArr[this.textArr.length - 1].tableInfo.tableHeight = currentHeightPx
        }
        fontScaleForTable = 1
        baseLineHeightPx = mainLineHeight
      }
    }else{
      needAdvance  = true
      if( !tableInfo || !tableInfo.first ){
        if(isHeading && (lastWasHeading === false)){
          //currentHeightPx += (lineHeightPx * 0.6);
          currentHeightPx += (lineHeightPx * 0.6);
        }else if(!isHeading && lastWasHeading){
          currentHeightPx -= (lineHeightPx * 0.3);
        }else if( isListItem){
          currentHeightPx += (lineHeightPx * 0.1);
        }else if( !isListItem && lastWasListItem){
          currentHeightPx += (lastLineHeight * 0.2);
        }
      }
      const children = section.children ?? [section]
      let markAsLastParagraph = false
      if( children ){
        let indent = startIndent
        let fragmentIdx = 0
        for(const frag of children ){
          if( frag.type === "unordered-list" || section.type === "ordered-list"){
            //console.error("THIS IS BEING CALLED")
            const px = "" + lineHeightPx
            if( !indentWidths[px] ){
              getDummyContext().font = (large ? this.headlineFont : this.standardFont)
              indentWidths[px] = this._getTextStats("    ").width
            }
            let preIndent = startIndent
            startIndent += indentWidths[px]
            
            currentHeightPx += (lineHeightPx * 0.2);
            if( frag.children ){
              for(const sub of frag.children ){
                processSection( sub, false, false )
              }
            }
            markAsLastParagraph = true
            startIndent = preIndent
          }else{

            const bold = frag.bold || isHeading  || tableInfo?.isHeader
            const italic = Boolean(frag.italic)
            const bullet = isListItem && (fragmentIdx === 0)
            const lastLine = lastSection && (fragmentIdx === (children.length - 1))
            const color = tableInfo?.isHeader ? (this.attrs.tableHeaderColor ?? "white") : undefined
            let text = frag.text
            let fragChildren = frag.children
            if( text !== undefined){

              text = text.replace(/^\s+/," ")

              const result = placeText( text, large, bold, italic, bullet, startIndent, indent, color, lastLine, tableInfo)
              indent = result.indent
              if( result.textWidth > maxUsedWidth ){
                maxUsedWidth = result.textWidth
              }
              didAdvance = result.newline
              if( result.clippedForHeight ){
                if( tableInfo ){
                  break
                }
                clipped = true
                break
              }
            }
            if( fragChildren ){
                    processSection( frag, false, false, isListItem )
                    didAdvance = true
            }
            fragmentIdx++
            if( !isListItem ){
              markAsLastParagraph = true
            }
          }
        }
        if(markAsLastParagraph && this.textArr[this.textArr.length - 1]) {
          this.textArr[this.textArr.length - 1].lastInParagraph = true;
        }
      }
    }
    if( this.attrs.leftBorder ){
      this.borderSections ||= []
      this.borderSections.push([startIndent - (lineHeightPx / 2), sectionStart, lineHeightPx / 10, currentHeightPx + lineHeightPx - sectionStart])
    }
    if( !didAdvance && needAdvance){
      currentHeightPx += (lineHeightPx * (isListItem ? 1.1 : (sectionSpacing ?? 1.4)));
    }
    
    lastWasHeading = isHeading
    lastWasListItem = isListItem
    if( needAdvance ){
      lastLineHeight = lineHeightPx
    }

  }

  let sIdx = 0
  for(const section of formattedList ){
    sIdx++
    processSection(section, sIdx === formattedList.length)
  }
  this.textHeight = fontSize;
  this.textWidth = maxUsedWidth;
  this._cachedHeight = this.height()

}

  _fontForFlags({ bold = false, italic = false, large = false } = {}) {
    if (large) {
      return italic ? this.headlineFontItalic : this.headlineFont;
    }
    if (bold && italic) {
      return this.boldFontItalic;
    }
    if (bold) {
      return this.boldFont;
    }
    if (italic) {
      return this.standardFontItalic;
    }
    return this.standardFont;
  }


checkCanvasCleared() {
  if( this.pcache){
    let canvas = this.pcache
    const ctx = this.pcache._canvas_context
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    
    for (let i = 3; i < imageData.data.length; i += 4) {
      if (imageData.data[i] !== 0) {
        return false;
      }
    }
    return true;
  }
  return false
}


  renderText(sceneContext){
    var textArr = this.textArr,
    textArrLen = textArr.length;

    let context
    if (!this.text()) {
      return;
    }

    this.textWasRendered = true

    var padding = this.padding(),
    fontSize = this.fontSize(),
    lineHeightPx = this.lineHeight() * fontSize,
    n,
    translateY = lineHeightPx / 2 ;

    if( DISABLE_CANVAS ){
      context = sceneContext
    }else{
      this.pcache._canvas_context.fillStyle = this.attrs.bgFill 
      this.pcache._canvas_context.fillRect(0,0,  this.uWidth, this.uHeight)
      context = this.pcache._canvas_context
    }
    const {scale, clipBox} = calcInheritedBounds( this )
    if (clipBox) {
      context.save();
      context.beginPath();
      context.rect(clipBox.x, clipBox.y, clipBox.width, clipBox.height);
      context.clip();
    }
    context.textBaseline = MIDDLE
    context.fillStyle = this.attrs.fill

    let alignCenter = this.attrs.align === "center"
    let alignRight = this.attrs.align === "right"
    let py = []
    var lineTranslateX = padding;
    var lineTranslateY = padding;

    let bold = false, large = false, italic = false, lastScale = 1, lastFill
    if( this.attrs.withMarkdown){
      
      context.font = this.standardFont

      for (n = 0; n < textArrLen; n++) {
        var obj = textArr[n], text = obj.text
        if( this.attrs.height && obj.y > this.attrs.height){
          break
        }
        if( bold !== obj.bold || large !== obj.large || italic !== Boolean(obj.italic)){
          bold = obj.bold
          large = obj.large
          italic = Boolean(obj.italic)
          context.font = this._fontForFlags({ bold, italic, large })
          if( lastScale !== 1){
            lastScale = undefined
          }
        }

        if( obj.fontScale !== lastScale ){
          lastScale = obj.fontScale
          let targetFont = context.font 
          const size = targetFont.match(/(\d+(?:\.\d+)?)px/)
          if( size ){
            const scaled = Math.max((size[1] * lastScale), 0.1)
            context.font = targetFont.replace(size[0], scaled + "px")
          }
        }
        let useColor = obj.color ?? this.attrs.fill
        if( useColor !== lastFill ){
          context.fillStyle = useColor
          lastFill = useColor
        }


        let offset = (obj.indent ?? 0)
        if( alignCenter ){
          offset += (this.attrs.width - obj.width) / 2
        }else if(alignRight){
          offset += (this.attrs.width - obj.width)
        }
        
        context.fillText(text, lineTranslateX + offset, obj.y)

        if( obj.bullet ){
          const r = Math.abs(obj.ascent / 6)
          context.beginPath();
          context.arc(lineTranslateX + offset - (r * 4), obj.y, r, 0, Math.PI * 2, false);
          context.closePath();
          context.fill();
        }
      }
    }else{
      context.font =this.fontCache
      for (n = 0; n < textArrLen; n++) {
        var obj = textArr[n],
        text = obj.text
        let offset = 0
        if( alignCenter ){
          offset += (this.attrs.width - obj.width) / 2
        }else if(alignRight){
          offset += (this.attrs.width - obj.width)
        }
        
        context.fillText(text, lineTranslateX + offset, translateY + lineTranslateY)
        
        if (textArrLen > 1) {
          translateY += lineHeightPx;
        }
      }
    }
    if (clipBox){
      context.restore();
    }
  }

  resetOwner(){
    this.queuedForRefresh = false
  }
  
  refreshCache(){
    this.queuedForRefresh = false
    const isFirst = !this.pcache
    if( isFirst ){
        this._buildPrivateCache()
    }
    if(this.pcache){
        if((this.newScale ?? this.lastScale) === this.lastRenderScale)
        {
          return
        }
        const ctx = this.pcache._canvas_context
        if( this.newScale){
            const rw = this.attrs.width//this.getWidth()
            const rh = this._cachedHeight//this.getHeight()
            const w = this.newScale * rw
            const h = this.newScale * rh
            if( w > 0 && h > 0){
                let doResize = true // w > this.pcache.width || h > this.pcache.height
                if( doResize ){
                    this.pcache.width = w//setSize( w, h)
                    this.pcache.height = h
                }
                ctx.setTransform(1, 0, 0, 1, 0, 0);
                ctx.scale( this.newScale ?? 1, this.newScale ?? 1)

                if( !doResize && !this.attrs.bgFill){
                    ctx.clearRect(0,0, rw + 5, rh + 5)
                }
                if( this.attrs.bgFill){
                  ctx.fillStyle = this.attrs.bgFill 
                  ctx.fillRect(0,0,  rw + 5, rh + 5)
                }

                this.uWidth = w 
                this.uHeight = h

                this.lastScale = this.newScale
                this.newScale = undefined
            }
        }
        this.renderText(  )
        this.lastRenderScale = this.lastScale
        this.refreshRequested = false
        if( isFirst ){
            this.requestRefresh()
        }
    }
  }
  destroy(){
    if( this.pcache ){
      //Util.releaseCanvas( this.pcache )
      this.pcache.width = 0
      this.pcache.height = 0
    }
    super.destroy()
  }
  _useBufferCanvas() {
    return false
  }

    
  constructor(attrs) {
    attrs.fontFamily ||= "Poppins"
    super(attrs);
    this.scaleRatio = 1
    this.rescaleMax = 1.5
    this.rescaleMin = 0.5
    this._cachedHeight = this.height()

  }

  requestRefresh(){
    if(this.attrs.refreshCallback && !this.placeholder){
        if(!this.queuedForRefresh ){
          this.queuedForRefresh = true
          this.attrs.refreshCallback(this)
          /*
          if( !this.refreshRequested || (performance.now() - this.refreshRequested > 100)){
            this.attrs.refreshCallback(this)
            this.refreshRequested = performance.now()
          }*/
        }
    }
    
  }
  getScale(){
    let scale = 1
    let parent = this.parent
    while (parent) {
      scale *= parent.attrs.scaleX ?? 1
      parent = parent.parent
    }
    return scale

  }


  _sceneFunc(context) {
    let scale = this.getScale()

    let w = this.attrs.width//this.width()
    let h = this._cachedHeight
    let fh = this.attrs.fontSize

    let ph = !DISABLE_CANVAS && !this.pcache
    const tooSmall = fh * scale < 6
    const previewMode = this.attrs._preview

    if( ph && !tooSmall){
        this.requestRefresh()
    }
    if( false && this.checkCanvasCleared()){
      console.warn(`CANVAS HAS BEEN CLEARED`)
      console.log(this)
      this.requestRefresh()
    }
    if( ph || tooSmall || previewMode){
        let ctx = context
        const {scale, clipBox} = calcInheritedBounds( this )
        if (clipBox) {
          ctx.save();
          ctx.beginPath();
          ctx.rect(clipBox.x, clipBox.y, clipBox.width, clipBox.height);
          ctx.clip();
        }

        let showLines = previewMode || fh * scale > 1.5
        if( showLines && this.attrs.showPlaceHolder !== false){
            
            const skeletonColor = previewMode ? "#ececec" : (this.attrs.placeholderFill ?? this.attrs.lineFill ?? "#eaeaea");
            ctx.fillStyle = skeletonColor;
            let y = 0, step = this.lineHeight() * fh 
            let alignCenter = this.attrs.align === "center"
            let alignRight = this.attrs.align === "right"
            const arr = this.textArr;
            if( arr && arr.length > 0 ){
              if( this.attrs.withMarkdown ){
                for(const d of arr){
                  let offset = 0
                  if( alignCenter ){
                    offset += (this.attrs.width - d.width) / 2
                  }else if(alignRight){
                    offset += (this.attrs.width - d.width)
                  }
                  ctx.fillRect(offset + d.indent, d.y, d.width - 1 , fh - 1)
                }
              }else{
                for(const d of arr){
                  let offset = 0
                  if( alignCenter ){
                    offset += (this.attrs.width - d.width) / 2
                  }else if(alignRight){
                    offset += (this.attrs.width - d.width)
                  }
                  ctx.fillRect(offset, y, d.width - 1 , fh - 1)
                  y += step
                }
              }
            } else if (previewMode) {
              // No textArr — draw generic skeleton bars filling the available area.
              const barH = Math.max(fh * 0.5, 4);
              const barGap = Math.round(fh * 0.6);
              const margin = 4;
              const widths = [w - margin * 2, w * 0.85, w * 0.62, w * 0.73, w * 0.48, w * 0.55];
              let wi = 0, lineY = barGap * 0.5;
              while (lineY + barH < h - barGap) {
                ctx.fillRect(margin, lineY, Math.max(widths[wi], margin * 2), barH);
                wi = (wi + 1) % widths.length;
                lineY += barH + barGap;
              }
            }
        }else{
          let steps = Math.min(Math.max(Math.ceil(h / 50), 2), 30)
          let step = Math.max(h / steps, 10)
          ctx.fillStyle = this.attrs.placeholderFill ?? this.attrs.lineFill ?? "#eaeaea"
          let widths = [w - 2, w * 0.8, w * 0.6, w * 0.7, w*0.2]
          let wi = 0
          for(let i = (step * 0.3); i < h ; i += step){
            ctx.fillRect(1, i,  widths[wi], step * 0.45)
            wi = (wi + 1) % 5
          }
        }
        if (clipBox){
          context.restore();
        }
    }else{
      if( DISABLE_CANVAS ){
        const {scale, clipBox} = calcInheritedBounds( this )
        if( this.tableDecoration ){
          const maxDrawWidth = (this.attrs.width ?? Infinity)
          const maxDrawHeight = (this.attrs.height ?? Infinity)
          for(const decoration of this.tableDecoration){
            const remainingWidth = maxDrawWidth - decoration.x
            const remainingHeight = maxDrawHeight - decoration.y
            if( remainingWidth <= 0 || remainingHeight <= 0){continue}
            const drawWidth = Math.min(decoration.width, remainingWidth)
            const drawHeight = Math.min(decoration.height, remainingHeight)
            if( drawWidth <= 0 || drawHeight <= 0){continue}
            if( decoration.type === "rect" ){
              if( decoration.fill){
                context.fillStyle = decoration.fill 
                context.fillRect( decoration.x, decoration.y, drawWidth, drawHeight)
              }
              if( decoration.stroke){
                context.strokeStyle = decoration.stroke
                context.lineWidth = 0.5
                context.strokeRect( decoration.x, decoration.y, drawWidth, drawHeight)
              }
            }              
          }
        }
        if( this.borderSections ){
          context.fillStyle = this.attrs.leftBorder
          for(const [x, y, w, h] of this.borderSections){
              if( x > this.attrs.width || (x + w - this.attrs.width) > 1){continue}
              if( y > this.attrs.height || (y + h - this.attrs.height) > 1){continue}
              if( clipBox ){
                if( y > (clipBox.y + clipBox.height)  ){
                  continue
                }
              }
              context.lineWidth = 0.5
              context.fillRect( x, y, w, h)
          }
        }
        this.renderText( context )
      }else{

        if( this.pcache.width > 0 && this.pcache.height > 0){
          const ratio = (scale / (this.lastScale )) 
          if( ratio < this.rescaleMin || ratio > this.rescaleMax){
            this.newScale = scale
            this.requestRefresh()
          }
          
          if( this.pcache ){
            context.drawImage(this.pcache, 0, 0, this.uWidth, this.uHeight, 0, 0, w, h)
          }
        }
      }
    }
  }
}

CustomText.prototype.className = 'CustomText';
_registerNode(CustomText);

/**
 * get/set width of text area, which includes padding.
 * @name Konva.Text#width
 * @method
 * @param {Number} width
 * @returns {Number}
 * @example
 * // get width
 * var width = text.width();
 *
 * // set width
 * text.width(20);
 *
 * // set to auto
 * text.width('auto');
 * text.width() // will return calculated width, and not "auto"
 */
Factory.overWriteSetter(CustomText, 'width', getNumberOrAutoValidator());

/**
 * get/set the height of the text area, which takes into account multi-line text, line heights, and padding.
 * @name Konva.Text#height
 * @method
 * @param {Number} height
 * @returns {Number}
 * @example
 * // get height
 * var height = text.height();
 *
 * // set height
 * text.height(20);
 *
 * // set to auto
 * text.height('auto');
 * text.height() // will return calculated height, and not "auto"
 */

Factory.overWriteSetter(CustomText, 'height', getNumberOrAutoValidator());


/**
 * get/set direction
 * @name Konva.Text#direction
 * @method
 * @param {String} direction
 * @returns {String}
 * @example
 * // get direction
 * var direction = text.direction();
 *
 * // set direction
 * text.direction('rtl');
 */
Factory.addGetterSetter(CustomText, 'direction', INHERIT);

/**
 * get/set font family
 * @name Konva.Text#fontFamily
 * @method
 * @param {String} fontFamily
 * @returns {String}
 * @example
 * // get font family
 * var fontFamily = text.fontFamily();
 *
 * // set font family
 * text.fontFamily('Arial');
 */
Factory.addGetterSetter(CustomText, 'fontFamily', 'Arial');

/**
 * get/set font size in pixels
 * @name Konva.Text#fontSize
 * @method
 * @param {Number} fontSize
 * @returns {Number}
 * @example
 * // get font size
 * var fontSize = text.fontSize();
 *
 * // set font size to 22px
 * text.fontSize(22);
 */
Factory.addGetterSetter(CustomText, 'fontSize', 12, getNumberValidator());

/**
 * get/set font style.  Can be 'normal', 'italic', or 'bold', '500' or even 'italic bold'.  'normal' is the default.
 * @name Konva.Text#fontStyle
 * @method
 * @param {String} fontStyle
 * @returns {String}
 * @example
 * // get font style
 * var fontStyle = text.fontStyle();
 *
 * // set font style
 * text.fontStyle('bold');
 */

Factory.addGetterSetter(CustomText, 'fontStyle', NORMAL);

/**
 * get/set font variant.  Can be 'normal' or 'small-caps'.  'normal' is the default.
 * @name Konva.Text#fontVariant
 * @method
 * @param {String} fontVariant
 * @returns {String}
 * @example
 * // get font variant
 * var fontVariant = text.fontVariant();
 *
 * // set font variant
 * text.fontVariant('small-caps');
 */

Factory.addGetterSetter(CustomText, 'fontVariant', NORMAL);

/**
 * get/set padding
 * @name Konva.Text#padding
 * @method
 * @param {Number} padding
 * @returns {Number}
 * @example
 * // get padding
 * var padding = text.padding();
 *
 * // set padding to 10 pixels
 * text.padding(10);
 */

Factory.addGetterSetter(CustomText, 'padding', 0, getNumberValidator());

/**
 * get/set horizontal align of text.  Can be 'left', 'center', 'right' or 'justify'
 * @name Konva.Text#align
 * @method
 * @param {String} align
 * @returns {String}
 * @example
 * // get text align
 * var align = text.align();
 *
 * // center text
 * text.align('center');
 *
 * // align text to right
 * text.align('right');
 */

Factory.addGetterSetter(CustomText, 'align', LEFT);

/**
 * get/set vertical align of text.  Can be 'top', 'middle', 'bottom'.
 * @name Konva.Text#verticalAlign
 * @method
 * @param {String} verticalAlign
 * @returns {String}
 * @example
 * // get text vertical align
 * var verticalAlign = text.verticalAlign();
 *
 * // center text
 * text.verticalAlign('middle');
 */

Factory.addGetterSetter(CustomText, 'verticalAlign', TOP);

/**
 * get/set line height.  The default is 1.
 * @name Konva.Text#lineHeight
 * @method
 * @param {Number} lineHeight
 * @returns {Number}
 * @example
 * // get line height
 * var lineHeight = text.lineHeight();
 *
 * // set the line height
 * text.lineHeight(2);
 */

Factory.addGetterSetter(CustomText, 'lineHeight', 1, getNumberValidator());

/**
 * get/set wrap.  Can be "word", "char", or "none". Default is "word".
 * In "word" wrapping any word still can be wrapped if it can't be placed in the required width
 * without breaks.
 * @name Konva.Text#wrap
 * @method
 * @param {String} wrap
 * @returns {String}
 * @example
 * // get wrap
 * var wrap = text.wrap();
 *
 * // set wrap
 * text.wrap('word');
 */

Factory.addGetterSetter(CustomText, 'wrap', WORD);

/**
 * get/set ellipsis. Can be true or false. Default is false. If ellipses is true,
 * Konva will add "..." at the end of the text if it doesn't have enough space to write characters.
 * That is possible only when you limit both width and height of the text
 * @name Konva.Text#ellipsis
 * @method
 * @param {Boolean} ellipsis
 * @returns {Boolean}
 * @example
 * // get ellipsis param, returns true or false
 * var ellipsis = text.ellipsis();
 *
 * // set ellipsis
 * text.ellipsis(true);
 */

Factory.addGetterSetter(CustomText, 'ellipsis', false, getBooleanValidator());

/**
 * set letter spacing property. Default value is 0.
 * @name Konva.Text#letterSpacing
 * @method
 * @param {Number} letterSpacing
 */

Factory.addGetterSetter(CustomText, 'letterSpacing', 0, getNumberValidator());

/**
 * get/set text
 * @name Konva.Text#text
 * @method
 * @param {String} text
 * @returns {String}
 * @example
 * // get text
 * var text = text.text();
 *
 * // set text
 * text.text('Hello world!');
 */

Factory.addGetterSetter(CustomText, 'text', '', getStringValidator());

/**
 * get/set text decoration of a text.  Possible values are 'underline', 'line-through' or combination of these values separated by space
 * @name Konva.Text#textDecoration
 * @method
 * @param {String} textDecoration
 * @returns {String}
 * @example
 * // get text decoration
 * var textDecoration = text.textDecoration();
 *
 * // underline text
 * text.textDecoration('underline');
 *
 * // strike text
 * text.textDecoration('line-through');
 *
 * // underline and strike text
 * text.textDecoration('underline line-through');
 */

Factory.addGetterSetter(CustomText, 'textDecoration', '');

export default CustomText;
